module.exports = __webpack_public_path__ + "img/salia-wappen.e4ebaf63.jpg";